var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.filteredProductToOrder,"headers":_vm.headers,"loading":_vm.loading,"dense":"","sort-by":"name","hide-default-footer":"","mobile-breakpoint":0,"items-per-page":_vm.productToOrder.length + 1}})}
var staticRenderFns = []

export { render, staticRenderFns }